"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleUnauthorizedAccess = void 0;
var react_1 = require("react");
var use_roles_effect_1 = require("../use-roles-effect");
var router_1 = require("next/router");
var useHandleUnauthorizedAccess = function () {
    var activeRole = (0, use_roles_effect_1.useRolesEffect)().activeRole;
    var basePath = (0, router_1.useRouter)().basePath; // i.e. '/assessments/admin'
    var pathByRole = use_roles_effect_1.roleRedirectMap.get(activeRole);
    var urlsReady = pathByRole && basePath;
    var isInAuthorizedApp = urlsReady && pathByRole.includes(basePath);
    (0, react_1.useEffect)(function () {
        if (activeRole && urlsReady && !isInAuthorizedApp)
            (0, use_roles_effect_1.handleUnauthorizedAccess)(activeRole);
    }, [activeRole, isInAuthorizedApp, urlsReady]);
};
exports.useHandleUnauthorizedAccess = useHandleUnauthorizedAccess;
